
export const _tab = () => {
	const tabTitles = document.querySelectorAll(".s-tabs__title");
	const tabTexts = document.querySelectorAll(".s-tabs__main-inner");

	if ( tabTitles.length && tabTexts.length ) {
		tabTitles[0].classList.add('is-active');
		tabTexts[0].classList.add('is-active');

		tabTitles.forEach(( title ) => {
			title.addEventListener( 'click', () => {
				let target = title.getAttribute('data-target');

				if (title.classList.contains('is-active')) {
					return;
				} else {
					tabTitles.forEach(( title ) => {
						title.classList.remove('is-active');
					})

					tabTexts.forEach(( text ) => {
						text.classList.remove('is-active');
					})

					title.classList.add('is-active');
					tabTexts[target-1].classList.add('is-active');
				}

			} )
		})
	}
}
